import Query from "../utils/Query";
import Documentation from '../models/Documentation';

export default class DocumentationService {

	static getAll(lang) {
		return Query.get('/items/documentation', {
			fields: '*,content.*',
			filter: {
				'content.language': lang,
			}
		}).then(response => response.data.map(documentation => new Documentation(documentation)));
	}
}
